export default __webpack_public_path__ + "static/pci-logo-1319b8e60fd543cf9d024e86686c323f.png";